import { createAction } from '@reduxjs/toolkit';
import type { TerminalState } from '../reducers/terminal';
import { paths } from '../schema/docs/api/admin';
import type { AppThunk } from '../store/configureStore';
import { throwOnError } from './utils';

type FetchTerminalResponse =
  paths['/api/terminals']['get']['responses']['200']['content']['application/json'];

type Terminals = TerminalState['terminals'];

export const GET_TERMINALS = createAction<Terminals>('GET_TERMINALS');

export const getTerminals =
  (query = ''): AppThunk =>
  (dispatch) =>
    fetch(`/api/terminals?${query}`, {
      method: 'GET',
      credentials: 'same-origin',
    })
      .then((response) => response.json())
      .then((data) => dispatch(GET_TERMINALS(data)));

export const fetchTerminals = (query = '') =>
  fetch(`/api/terminals?${query}`, {
    method: 'GET',
    credentials: 'same-origin',
  }).then(throwOnError<FetchTerminalResponse>);
